import {
  isMessagesQuotaExceeded,
  isMessagesQuotaWarning,
  type MessagesQuota,
} from 'types/account/messagesQuota';
import type { HeaderSettingsAlertCheck, HeaderSettingsAlertIssue } from 'utils/headerSettingsAlert/types';

export const SUBSCRIPTION_PAYMENTS_FIX_PATH = '/account/subscription-details';

function buildQuotaIssue(
  id: string,
  messagePath: string,
  quota: MessagesQuota,
): HeaderSettingsAlertIssue {
  return {
    id,
    messagePath,
    messageValues: {
      remaining: quota.remaining,
      limit: quota.limit,
      used: quota.used,
    },
    fixPath: SUBSCRIPTION_PAYMENTS_FIX_PATH,
    fixTargetKey: 'subscriptionPayments',
    severity: 'error',
  };
}

export const messagesQuotaCheck: HeaderSettingsAlertCheck = {
  id: 'messages-quota',
  run(ctx): HeaderSettingsAlertIssue[] {
    if (ctx.currentUserRole !== 'admin') return [];

    const quota = ctx.messagesQuota;
    if (!quota || quota.limit <= 0) return [];

    if (isMessagesQuotaExceeded(quota)) {
      return [buildQuotaIssue('messages-quota-exceeded', 'header.settingsAlert.summary.messagesQuotaExceeded', quota)];
    }

    if (isMessagesQuotaWarning(quota)) {
      return [buildQuotaIssue('messages-quota-warning', 'header.settingsAlert.summary.messagesQuotaWarning', quota)];
    }

    return [];
  },
};
